module.exports = __webpack_public_path__ + "static/react-platforms-24b7ee5e00971aa949f849a50002a8c7.png";